import { Sprout, Droplet, Sun, ShoppingBag, Users, Scissors } from 'lucide-react'
import { useI18n } from '../i18n/I18nProvider'

function Help() {
  const { t } = useI18n()
  const faqs = [
    {
      question: t('help.faq.faqs.howToPlant.question'),
      answer: t('help.faq.faqs.howToPlant.answer'),
    },
    {
      question: t('help.faq.faqs.howToGrow.question'),
      answer: t('help.faq.faqs.howToGrow.answer'),
    },
    {
      question: t('help.faq.faqs.howToGetSeeds.question'),
      answer: t('help.faq.faqs.howToGetSeeds.answer'),
    },
    {
      question: t('help.faq.faqs.seedPurpose.question'),
      answer: t('help.faq.faqs.seedPurpose.answer'),
    },
    {
      question: t('help.faq.faqs.autoGardener.question'),
      answer: t('help.faq.faqs.autoGardener.answer'),
    },
    {
      question: t('help.faq.faqs.howToolsWork.question'),
      answer: t('help.faq.faqs.howToolsWork.answer'),
    },
    {
      question: t('help.faq.faqs.howToShare.question'),
      answer: t('help.faq.faqs.howToShare.answer'),
    },
    {
      question: t('help.faq.faqs.prunerPurpose.question'),
      answer: t('help.faq.faqs.prunerPurpose.answer'),
    },
  ]

  return (
    <div className="container mx-auto px-4 py-12">
      <div className="max-w-4xl mx-auto">
        <h1 className="text-4xl font-bold text-green-800 mb-4 text-center">
          {t('help.title')}
        </h1>
        <p className="text-gray-600 text-center mb-12">
          {t('help.subtitle')}
        </p>

        {/* Game Mechanics */}
        <div className="mb-12">
          <h2 className="text-2xl font-bold text-gray-800 mb-6">
            {t('help.gameMechanics.title')}
          </h2>
          
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div className="bg-white rounded-xl shadow-lg p-6">
              <Sprout size={32} className="text-green-600 mb-4" />
              <h3 className="text-xl font-bold mb-2">{t('help.gameMechanics.plant.title')}</h3>
              <p className="text-gray-600">
                {t('help.gameMechanics.plant.description')}
              </p>
            </div>

            <div className="bg-white rounded-xl shadow-lg p-6">
              <Droplet size={32} className="text-blue-600 mb-4" />
              <h3 className="text-xl font-bold mb-2">{t('help.gameMechanics.water.title')}</h3>
              <p className="text-gray-600">
                {t('help.gameMechanics.water.description')}
              </p>
            </div>

            <div className="bg-white rounded-xl shadow-lg p-6">
              <Sun size={32} className="text-yellow-600 mb-4" />
              <h3 className="text-xl font-bold mb-2">{t('help.gameMechanics.sun.title')}</h3>
              <p className="text-gray-600">
                {t('help.gameMechanics.sun.description')}
              </p>
            </div>

            <div className="bg-white rounded-xl shadow-lg p-6">
              <Scissors size={32} className="text-gray-600 mb-4" />
              <h3 className="text-xl font-bold mb-2">{t('help.gameMechanics.prune.title')}</h3>
              <p className="text-gray-600">
                {t('help.gameMechanics.prune.description')}
              </p>
            </div>

            <div className="bg-white rounded-xl shadow-lg p-6">
              <ShoppingBag size={32} className="text-purple-600 mb-4" />
              <h3 className="text-xl font-bold mb-2">{t('help.gameMechanics.shop.title')}</h3>
              <p className="text-gray-600">
                {t('help.gameMechanics.shop.description')}
              </p>
            </div>

            <div className="bg-white rounded-xl shadow-lg p-6">
              <Users size={32} className="text-pink-600 mb-4" />
              <h3 className="text-xl font-bold mb-2">{t('help.gameMechanics.community.title')}</h3>
              <p className="text-gray-600">
                {t('help.gameMechanics.community.description')}
              </p>
            </div>
          </div>
        </div>

        {/* FAQ */}
        <div>
          <h2 className="text-2xl font-bold text-gray-800 mb-6">
            {t('help.faq.title')}
          </h2>
          
          <div className="space-y-4">
            {faqs.map((faq, index) => (
              <details
                key={index}
                className="bg-white rounded-xl shadow-lg overflow-hidden"
              >
                <summary className="px-6 py-4 font-bold text-gray-800 cursor-pointer hover:bg-gray-50 transition">
                  {faq.question}
                </summary>
                <div className="px-6 pb-4 text-gray-600">
                  {faq.answer}
                </div>
              </details>
            ))}
          </div>
        </div>
      </div>
    </div>
  )
}

export default Help
